<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Eventos pasados",
            items: [
                {
                text: "Eventos",
                href: "/"
                },
                {
                text: "Pasados",
                active: true
                }
            ],
            eventos:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
        };
    },
    computed:{
        filteredData() {
            // Filtramos los datos en base al campo 'filtro' 
            return this.eventos.filter((item) => {
                // Aquí puedes personalizar los campos a buscar
                return (
                    item.codigo.toLowerCase().includes(this.filtro.toLowerCase()) ||
                    item.nombre_difusion.toLowerCase().includes(this.filtro.toLowerCase())
                );
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalRows() {
            return this.filteredData.length;
        },
    },
    methods:{
        agregar_laborantes(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventolaborantes";
        },
        ver_evento(evento){
            localStorage.setItem('evento_codigo',evento);
            window.location.href = "/web/configuracion/eventos";
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY HH:mm');
            return orden
        },
    },
    created(){
        axios.get('/api/get_eventos_iniciados').then(res=>{
            this.eventos=res.data.eventos.sort((a, b) => new Date(b.fecha_inicio) - new Date(a.fecha_inicio));;
            console.log(this.eventos)
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="col-md-12">
            <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-history font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Eventos Pasados</h5>
                            <small class="text-white" style="opacity:.8;">Revisa los eventos ya realizados</small>
                        </div>
                    </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_length" class="dataTables_length">
                                <label class="d-inline-flex align-items-center">
                                    Mostrar&nbsp;
                                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                <label class="d-inline-flex align-items-center">
                                    Buscar:
                                    <b-form-input
                                    v-model="filtro"
                                    type="search"
                                    placeholder="Buscar..."
                                    class="form-control form-control-sm ml-2"
                                    ></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive mb-0 mt-3">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th style="width: 5%;">Nº</th>
                                    <th style="width: 10%;">Código</th>
                                    <th style="width: 30%;">Actividad</th>
                                    <th style="width: 15%;">Fecha Inicio</th>
                                    <th style="width: 25%;">Colegio</th>
                                    <th style="width: 20%;">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in paginatedData" :key="index">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ item.codigo }}</td>
                                    <td>{{ item.nombre_difusion }}</td>
                                    <td>{{ formatFecha(item.fecha_inicio) }}</td>
                                    <td>{{ item.colegio }}</td>
                                    <td>
                                        <b-button variant="primary" size="sm" @click="ver_evento(item.codigo)">Ver</b-button>
                                        <b-button variant="primary" size="sm" @click="agregar_laborantes(item.codigo)">Agregar Laborantes</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>